import "./CategoryFilter.scss";
import { ReactComponent as EditIcon } from "../../images/EditIcon.svg";

const CategoryFilter = ({ filters = [], activeFilter, onFilterChange }) => {
  return (
    <div className="category-filter-container">
      {filters.map((filter) => {
        const isActive = activeFilter === filter.id;
        const IconComponent = filter.icon;

        return (
          <div
            key={filter.id}
            className={`filter-btn ${isActive ? "active" : ""}${filter.onDelete ? " has-delete" : ""}${filter.onEdit ? " has-edit" : ""}`}
            onClick={() => onFilterChange(filter.id)}
          >
            {IconComponent && <IconComponent />}
            {filter.iconSrc && (
              <img
                src={filter.iconSrc}
                alt={filter.label}
                style={{
                  width: 20,
                  height: 20,
                  filter: isActive ? "invert(0) brightness(2)" : "none",
                  transition: "filter 0.3s ease",
                }}
              />
            )}
            <span>{filter.label}</span>
            {filter.onEdit && (
              <button
                type="button"
                className="filter-edit-btn"
                aria-label={`${filter.editLabel}: ${filter.label}`}
                title={filter.editLabel}
                onClick={(event) => {
                  event.stopPropagation();
                  filter.onEdit();
                }}
              >
                <EditIcon aria-hidden="true" />
              </button>
            )}
            {filter.onDelete && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  filter.onDelete(filter.id);
                }}
                className="filter-delete-btn"
                style={{
                  filter: isActive ? "invert(0) brightness(2)" : "none",
                }}
                aria-label={`Delete ${filter.label}`}
                title={`Delete ${filter.label}`}
              >
                ×
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CategoryFilter;
